import { useEffect } from "react";
import { Button, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import Query from "../common/Query";
import { FormSubmission } from "../form/types";
import { formatDate } from "../utils";
import FORMSUBMISSION_QUERY from "./queries/FORMSUBMISSION_QUERY";
import DOWNLOADURL_QUERY from "./queries/DOWNLOADURL_QUERY";

let formId = "";
let email = "";
const DownloadUrl = ({ fileName }: { fileName: string }) => {
  const [getDownloadUrl, { data }] = useLazyQuery(DOWNLOADURL_QUERY);
  useEffect(() => {
    if (data) {
      window.location = data.downloadUrl;
    }
  }, [data]);
  return (
    <Button
      variant="link"
      onClick={() => getDownloadUrl({
          variables: { blobName: `${formId}/${email}/${fileName}` },
        })
      }
    >
      {fileName}
    </Button>
  );
};
const returnIfKeyMatch = (k:string, obj:any) => {
  if (k[0] === "_") return {matched: true, value: null};
  switch(k) {
    case "id":
    case "createdAt":
    case "updatedAt":
      return {matched: true, value: null};
    case "fileType":
      return {matched: true, value: <DownloadUrl key={k} fileName={obj["name"]} />};
  }
};
const returnIfTypeof = (k:string, value: any) => {
  switch(typeof value) {
    case "undefined":
      return {return: true, value: null};
    case "object":

      return value ? {return:true, value: (
        <Card className="mb-2" key={k}>
          {isNaN(+k) && <Card.Header>{k}</Card.Header>}
          <Card.Body>{objectToText(value)}</Card.Body>
        </Card>
      )} : null;
  }
};
const formatValue = (v:any) => {
  return (typeof v === 'string' && v[v.length - 1] === "Z") ? formatDate(v) : v;
};
const objectToText = (obj: any): any[] | null => {
  return obj ? Object.keys(obj).map((k) => {
    let v = obj[k];
    const match = returnIfKeyMatch(k, obj);
    if (match?.matched) {
      return match.value;
    }
    const result = returnIfTypeof(k, v);
    if (result?.return) {
      return result.value;
    }
    return (
      <div key={k} className="mb-1">
        {isNaN(+k) ? `${k}: ` : ""}
        <strong>{formatValue(v)}</strong>
      </div>
    );
  }) : null;
};

const FormSubmissionView = () => {
  const { submissionId }: { submissionId?: string } = useParams();

  return (
    <Query
      loadingLabel="Loading Your Submission"
      variables={{ id: submissionId }}
      query={FORMSUBMISSION_QUERY}
    >
      {({ data: { submission } }: { data: { submission: FormSubmission } }) => {
        if (!formId) formId = (submission.form?.id as string);
        if (!email) email = submission.payload?.user?.email;
        return (
          <>
            <h1 className="mb-2">{submission?.form?.title}</h1>
            <p>{formatDate(submission.createdAt)}</p>
            {objectToText(submission.payload)}
          </>
        );
      }}
    </Query>
  );
};

export default FormSubmissionView;
